@let timeRemaining = timeRemaining$ | async;
@let auction = auction$ | async;

<div
  class="countdown-widget"
  [style.background-color]="backgroundColor"
  [style.color]="textColor"
  [style.font-family]="fontFamily"
  [style.font-weight]="fontWeight"
  [style.border-color]="borderColor"
  [style.border-width.cqw]="borderWidth"
  [style.border-style]="borderStyle"
>
  @if (timeRemaining && !timeRemaining.isExpired) {
    <span class="countdown-display" [style.font-size.cqw]="fontSize" [style.letter-spacing.cqw]="letterSpacing">
      @if (timeRemaining.days > 0) {
        <span class="time-unit">
          <span class="time-value">{{ timeRemaining.days }}</span>
          <span class="time-label">d</span>
        </span>
      }
      @if (timeRemaining.days > 0 || timeRemaining.hours > 0) {
        <span class="time-unit">
          <span class="time-value">{{ timeRemaining.hours.toString().padStart(2, '0') }}</span>
          <span class="time-label">h</span>
        </span>
      }
      @if (timeRemaining.days > 0 || timeRemaining.hours > 0 || timeRemaining.minutes > 0) {
        <span class="time-unit">
          <span class="time-value">{{ timeRemaining.minutes.toString().padStart(2, '0') }}</span>
          <span class="time-label">m</span>
        </span>
      }
      @if (
        timeRemaining.days > 0 || timeRemaining.hours > 0 || timeRemaining.minutes > 0 || timeRemaining.seconds > 0
      ) {
        <span class="time-unit">
          <span class="time-value">{{ timeRemaining.seconds.toString().padStart(2, '0') }}</span>
          <span class="time-label">s</span>
        </span>
      }

      @if (countdownWidget?.plus_overtime_label && auction?.enable_scheduled_time_extend) {
        <span class="overtime-label">{{ 'PRESENTER.COUNTDOWN_WIDGET.PLUS_OVERTIME' | translate }}</span>
      }
    </span>
  } @else {
    <span class="timeout-text" [style.font-size.cqw]="fontSize">
      {{ timeoutText }}
    </span>
  }
</div>
